import { render } from "./SectionHead.vue?vue&type=template&id=e0b4af44"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__